//Vista de la respuesta al completar un formulario remoto correctamente 

import React from 'react';
//import 'antd/dist/antd.css';
import {Result} from 'antd';

// Componente que se muestra finalmente
class Successful extends React.Component {

    render() {
        return (
            <div>
                <Result
                    status="success"
                    title="Solicitud enviada exitosamente!"
                    subTitle="Actualmente estamos procesando tu información, te contactaremos por cualquier novedad."
                />
            </div>
        );
    }
}

export default Successful;